import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { LocalidadeComponent } from './localidade.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule
    ],
    declarations: [
        LocalidadeComponent,
    ],
    exports: [
      LocalidadeComponent,
    ],
})

export class LocalidadeComponentModule {
}
